<ng-container *ngIf="lessonsWithParentAcc$ | async as lessonsWithParent;">
    <ng-container *ngFor="let lessonWithParent of lessonsWithParent; let index=index">
        <ng-template [ngTemplateOutlet]="templateRef" [ngTemplateOutletContext]="{
                        lesson: lessonWithParent.lesson,
                        parent: lessonWithParent.parentLesson,
                        index: index
                    }"></ng-template>
    </ng-container>
    <ng-container *ngIf="lessonsWithParent.length === 0 && !isLoading && hasMorePageToLoad() === false">
        {{ 'activity_search.no_lessons_found' | translate }}
    </ng-container>
</ng-container>
<mat-spinner *ngIf="isLoading || ((lessonsWithParentAcc$ | async).length === 0 && hasMorePageToLoad())"></mat-spinner>
